<template>
    <div component="OrderFooter">
        <order-footer-action />

        <div class="summary">
            <!--            <div class="line vat">-->
            <!--                <div>20% VAT:</div>-->
            <!--                <div class="val">{{ getOrderProject ? getOrderProject.price.only_dph : 0 }} <small>EUR</small></div>-->
            <!--            </div>-->
            <div class="line total">
                <div>Total price:</div>
                <div class="val">{{ getOrderProject ? getOrderProject.price.base_price : 0 }} <small>EUR</small></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import OrderFooterAction from '@/components/Project/Order/OrderFooterAction';

export default {
    name: 'OrderFooter',

    data() {
        return {
            showOrderConfirm: false,
        };
    },

    async created() {},

    async mounted() {},

    methods: {
        ...mapActions([]),
        ...mapMutations([]),
    },

    computed: {
        ...mapGetters(['getOrderProject']),
    },

    watch: {},

    components: { OrderFooterAction },
};
</script>

<style lang="less">
@import '~@variables';

[component='OrderFooter'] {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 15px 0 0;

    .line {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 12px;

        .val {
            text-align: right;
            font-weight: bold;
            font-size: 14px;
            color: @black;
            min-width: 110px;
        }
    }
}
</style>
